import { StyleSheet } from 'lib/paypalphrodite'

export default StyleSheet.create({
  generalWrapper: {
    width: '100%',
    maxWidth: '560px',
    margin: 'auto',
    borderRadius: '5px',
    backgroundColor: 'white',
    border: 'solid 1px #9da3a6',
    boxSizing: 'border-box',
    fontSize: '15px',
    lineHeight: '1.4',
  },
  PrimaryFontFamily: {
    fontWeight: 'normal',
    WebkitFontSmoothing: 'antialiased',
    MozFontSmoothing: 'antialiased',
    msFontSmoothing: 'antialiased',
    OFontSmoothing: 'antialiased',
    fontSmoothing: 'antialiased',
  },
  // good for use with <H2>s

  ViewHeaderText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    margin: 0,
    padding: 0,
  },
})

export const colors = {
  text: '#333333',
  grey: '#cbd2d6',
  lightGrey: '#D6D6D6',
  checkmarkGreen: '#018065',
  vxDarkerGray: '#2c2e2f',
  vxAccessibleBlue: '#0070BA',
}

export const screenSizes = {
  phoneLandscapeMax: 640,
  iphone5portrait: 320,
  iphone6portrait: 375,
  iphone6Plusportrait: 414,
}

export const mediaQueries = {
  phoneLandscapeMax: `@media (max-width: ${screenSizes.phoneLandscapeMax}px)`,
  phoneLandscapeMin: `@media (min-width: ${screenSizes.phoneLandscapeMax +
    1}px)`,
  phone5PortraitMax: `@media (max-width: ${screenSizes.iphone5portrait}px)`,
  phone6PortraitMax: `@media (max-width: ${screenSizes.iphone6portrait}px)`,
  phone6PlusPortraitMax: `@media (max-width: ${screenSizes.iphone6Plusportrait}px)`,
  // Targeting IE10+ with media query (https://philipnewcomer.net/2014/04/target-internet-explorer-10-11-css/)
  internetExplorer10and11: `@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)`,
}
